var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import "@frameworks/salesjourney/stylesheets/components/Features/LeadGenerate/lead.scss";
// import "../stylesheets/components/Generic/Generic.scss";
import Footer from "./Footer/Footer";
import "@frameworks/shared-library/assets/scss/variables/fontFamily.scss";
import "@frameworks/shared-library/assets/icons/edel_icons/style.scss";
import "@frameworks/shared-library/assets/scss/global/global.scss";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
// import "../../shared-library/stylesheets/components/index.scss";
import homeDI from "@frameworks/salesjourney/components/Home/di/index";
import { getQueryParameterName } from "@frameworks/salesjourney/utils/genericMethods";
import loginDi from "../components/Login/di/index";
import profileDI from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import { useSelector } from "react-redux";
import { autorize } from "@salesdi";
import Loader from "@frameworks/shared-library/components/Loader";
import ErrorNotification, { ErrorDisplayType, } from "./Generic/ErrorNotification";
import DashboardRouting from "./dashboardRouting";
import ClientDetailsRouting from "./Features/ClientDetails/clientDetailsRouting";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "@redux/store/persistStore";
import filterDI from "@frameworks/salesjourney/components/filterDi/serviceLocator";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import encryptionDi from "@mainDi/features/Encryption/servicelocator";
import { useLocation } from "react-router-dom";
export default function Index() {
    var _this = this;
    var _a = __read(React.useState(false), 2), showSessionPopup = _a[0], setSessionShowPopup = _a[1];
    var cipToken = getQueryParameterName("Token");
    var navigate = useNavigate();
    var location = useLocation();
    var isSavedProducts = location.pathname
        .toLowerCase()
        .includes("saved-products");
    var isProductBouquet = location.pathname
        .toLowerCase()
        .includes("product-bouquet");
    var getLoginData = function () {
        var loginReq = {
            authToken: cipToken,
        };
        loginDi.login
            .getLoginData(loginReq)
            .then(function (loginCIPResponse) {
            if (loginCIPResponse.loginResponse) {
                navigate("/dashboard", { replace: true });
            }
            else {
                window.open(URLConfig.config.applicationFolder + "/login", "_blank");
                filterDI.filter.updateFinalFilterState({});
                setSessionShowPopup(true);
            }
        });
        //
    };
    var getExpiringLeads = function () {
        var req = {
            page: "1",
            pageSize: "100",
        };
        homeDI.home.getExpiringLeads(req);
    };
    React.useEffect(function () {
        if (cipToken)
            getLoginData();
    }, [cipToken]);
    React.useEffect(function () {
        if (!isProductBouquet && !isSavedProducts) {
            localStorage.removeItem("CategoryCode");
        }
    }, [location]);
    var access_token = localStorage.getItem(ELocalStorageKeys.AccessToken);
    var _b = useSelector(function (state) { return state.Login.LoginReducer.commonData; }), loginLoader = _b.loader, loginError = _b.errorData;
    var getDecodedTokenData = function (token) { return __awaiter(_this, void 0, void 0, function () {
        var decodedToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, autorize.getDecodedToken(token)];
                case 1:
                    decodedToken = _a.sent();
                    return [2 /*return*/, decodedToken];
            }
        });
    }); };
    var getProfilImage = function () { return __awaiter(_this, void 0, void 0, function () {
        var profileImage, error_1, errorCode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, profileDI.profile.getProfileImage()];
                case 1:
                    profileImage = _a.sent();
                    if (profileImage) {
                        setSessionShowPopup(false);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    errorCode = error_1.getHttpCode();
                    if (errorCode === 401 || errorCode === 403) {
                        filterDI.filter.updateFinalFilterState({});
                        setSessionShowPopup(true);
                        // setErrorData(error as EdelError);
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // const { errorData: errorState } = useSelector(
    //   (state: RootState) => state.Profile.ProfileDetails.commonData
    // );
    React.useEffect(function () {
        // if (!showSessionPopup) {
        getProfilImage();
        // }
    });
    // const befoeUnLoadEventFun = () => {
    //   window.addEventListener("beforeunload", (ev) => {
    //     ev.preventDefault();
    //     console.log("Event ", ev);
    //     localStorage.removeItem("loginType");
    // use enum for localstorage key
    //     localStorage.removeItem("access_token");
    //     loginDi.login.clearLoginToken();
    //     // window.location.href = URLConfig.config.applicationRoot + "login";
    //     return (ev.returnValue = "Are you sure you want to close?");
    //   });
    // };
    // React.useEffect(() => {
    //   befoeUnLoadEventFun();
    //   return () => {
    //     window.removeEventListener("beforeunload", befoeUnLoadEventFun);
    //   };
    // }, []);
    React.useEffect(function () {
        var retryCount = 0;
        var getServerKeyWithRetry = function () {
            encryptionDi.encryption
                .getServerKey()
                .then(function (data) {
                console.log(data);
            })
                .catch(function (error) {
                retryCount++;
                if (retryCount < 3) {
                    console.log("Retrying... ".concat(retryCount));
                    getServerKeyWithRetry();
                }
                else {
                    console.log("Max retries reached. API call failed.");
                }
            });
        };
        var getServerKey = localStorage.getItem("serverKey");
        if (!getServerKey) {
            getServerKeyWithRetry();
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(PersistGate, { loading: null, persistor: persistor },
            loginLoader && React.createElement(Loader, null),
            showSessionPopup && (React.createElement(ErrorNotification, { displayType: ErrorDisplayType.POPUP, showSessionPopup: showSessionPopup })),
            React.createElement(Routes, null,
                React.createElement(Route, { index: true, path: "/dashboard/*", element: React.createElement(DashboardRouting, null) }),
                React.createElement(Route, { path: "/clientdetails/*", element: React.createElement(ClientDetailsRouting, null) }),
                React.createElement(Route, { path: "/clientdetails/", element: React.createElement(Navigate, { to: "/clientdetails/overview?link=overview" }) }),
                React.createElement(Route, { path: "/", element: React.createElement(Navigate, { to: "/dashboard" }) })),
            React.createElement(Footer, null))));
}
